import { useAppDispatch } from '@/shared/lib/redux'
import {
    openPaymentModal as openPaymentModalAction,
} from '../model'
import { IBooking } from '@/shared/api/aviabooking'

export const useBookingPaymentModal = () => {
    const dispatch = useAppDispatch()

    const openPaymentModal = (booking: IBooking, onPayment?: () => void) => {
        dispatch(openPaymentModalAction({
            booking,
            onPayment
        }))
    }
    
    return {
        openPaymentModal,
    }
}